import { Header } from "../header/Header";
import { Screen } from "./Screen";
import React, { PropsWithChildren } from "react";

interface ApplicationScreenProps extends PropsWithChildren {
    withUser?: boolean;
}
export function ApplicationScreen({
    withUser = true,
    children
}: ApplicationScreenProps) {
    return (
        <Screen>
            <Header withUser={withUser} />
            <div className={"min-h-side-bar flex"}>{children}</div>
        </Screen>
    );
}
